<script setup>import { computed as _computed } from 'vue';

  import DropdownWidget from "./dropdown-widget.vue";
  import {
    activateShipmentPath,
    cancelShipmentPath,
    copyShipmentPath,
    editShipmentPath,
    reopenShipmentPath,
    shipShipmentPath,
  } from "~/routes";

  const props = defineProps({
    shipment: { type: Object, required: true },
    confirms: { type: Object, required: true },
  });

  const reopenConfirm = _computed(() => {
    if (props.shipment.state === "cancelled") return props.confirms.reopen_cancelled;
    if (props.shipment.state === "active") return props.confirms.reopen_active;

    return props.confirms.reopen;
  });

  const cancelConfirm = _computed(() => {
    if (props.shipment.items_count === 0) return props.confirms.cancel_empty;
    if (props.shipment.state === "shipped") return props.confirms.cancel_shipped;

    return props.confirms.cancel;
  });
</script>

<template>
  <DropdownWidget>
    <template #trigger>
      <button class="button is-outlined is-info is-small">
        <span>Actions</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down"></i>
        </span>
      </button>
    </template>

    <template #content>
      <a
        v-if="shipment.actions?.includes('edit')"
        class="dropdown-item"
        :href="editShipmentPath(shipment.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-pen-to-square"></i></span>
          <span>Edit</span>
        </span>
      </a>
      <a class="dropdown-item" data-method="post" :href="copyShipmentPath(shipment.id)">
        <span class="icon-text">
          <span class="icon"><i class="fa fa-copy"></i></span>
          <span>Duplicate</span>
        </span>
      </a>
      <a
        v-if="shipment.actions?.includes('ship')"
        class="dropdown-item"
        data-method="post"
        :data-confirm="confirms.ship"
        :href="shipShipmentPath(shipment.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa-duotone fa-truck-fast"></i></span>
          <span>Ship</span>
        </span>
      </a>
      <a
        v-if="shipment.actions?.includes('activate')"
        class="dropdown-item"
        data-method="post"
        :href="activateShipmentPath(shipment.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-play"></i></span>
          <span>Set Active</span>
        </span>
      </a>
      <a
        v-if="shipment.actions?.includes('reopen')"
        class="dropdown-item"
        data-method="post"
        :data-confirm="reopenConfirm"
        :href="reopenShipmentPath(shipment.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-rotate-left"></i></span>
          <span>Reopen</span>
        </span>
      </a>
      <a
        v-if="shipment.actions?.includes('cancel')"
        class="dropdown-item"
        data-method="post"
        :data-confirm="cancelConfirm"
        :href="cancelShipmentPath(shipment.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-xmark"></i></span>
          <span>Cancel</span>
        </span>
      </a>
    </template>
  </DropdownWidget>
</template>
